import * as LabelPrimitive from '@radix-ui/react-label'
import { Primitive } from '@radix-ui/react-primitive'
import { type VariantProps, cva } from 'class-variance-authority'
import clsx from 'clsx'
import * as React from 'react'

import Styles from './Label.module.scss'

const labelVariants = cva(Styles.labelBase, {
  variants: {
    layout: {
      row: Styles.row,
      'spaced-row': Styles.spacedRow,
      column: Styles.column
    },
    variant: {
      outline: Styles.outline,
      default: Styles.default
    }
  },
  defaultVariants: {
    variant: 'default',
    layout: 'row'
  }
})

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({ className, variant, layout, ...props }, ref) => {
  return (
    <Primitive.label
      ref={ref}
      className={clsx(labelVariants({ variant, layout }), className)}
      {...props}></Primitive.label>
  )
})
Label.displayName = LabelPrimitive.Root.displayName

export { labelVariants }
export default Label
